var __jsx = React.createElement;
import React from 'react';
import Typography from '@atoms/Typography';
import Grid from '@mui/material/Grid';
import { HeaderContainer, TitleContainer } from './style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    children = _ref.children;
  return /*#__PURE__*/_jsxs(Grid, {
    container: true,
    children: [/*#__PURE__*/_jsx(Grid, {
      item: true,
      xs: 12,
      md: 4,
      children: /*#__PURE__*/_jsxs(TitleContainer, {
        children: [icon, /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          children: title
        })]
      })
    }), /*#__PURE__*/_jsx(Grid, {
      item: true,
      xs: 12,
      md: 8,
      children: children
    })]
  });
};
PageHeader.defaultProps = {
  children: undefined,
  icon: undefined
};
export default PageHeader;